import { z } from "zod";

// The scope literals mirror PERMISSION_SCOPES in @msuite/citadel. utils cannot import citadel —
// citadel already depends on this package — so the handler re-validates every entry against the
// canonical scope map and refuses loudly if the two ever drift.
const scopeSchema = z.enum(["organization", "own", "ownProjects"]);

/**
 * The permission editor's payload: one entry per `action:subject` cell, `false` for revoked,
 * otherwise the chosen scope. The keys stay an open record — this package may not import the
 * manifest — so the handler matches every key against it before anything is written, exactly as
 * the individual grid's write path does.
 */
export const rolePermissionFormSchema = z.object({
	grants: z.record(z.string(), z.union([z.literal(false), scopeSchema])),
});

export type RolePermissionFormSchema = z.infer<typeof rolePermissionFormSchema>;
